<template>
  <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
    <template #trigger>
      <button
        class="button"
        :class="{
          'is-success': invoice && invoice.status === 'emitted',
          'is-danger':
            invoice &&
            (invoice.status === 'error' || invoice.status === 'rejected'),
          'is-dark': invoice && invoice.status === 'cancelled',
          'is-warning': invoice && invoice.status === 'pending',
          'is-info': invoice && invoice.status === 'notApplicable'
        }"
        :disabled="invoice && invoice.status === 'notSent'"
        slot="trigger"
      >
        {{
          invoice.status === "emitted"
            ? $t("transactions.emitted")
            : invoice.status === "pending"
            ? $t("transactions.pending")
            : invoice.status === "error"
            ? $t("transactions.error")
            : invoice.status === "rejected"
            ? $t("transactions.rejected")
            : invoice.status === "cancelled"
            ? $t("transactions.cancelled")
            : invoice.status === "notSent"
            ? $t("transactions.notSent")
            : invoice.status === "notEnabled"
            ? $t("transactions.notEnabled")
            : invoice.status === "notApplicable"
            ? $t("transactions.notApplicable")
            : "-"
        }}
      </button>
    </template>

    <b-dropdown-item
      @click="copyContent(transactionId, 'ID da transação copiado!')"
      aria-role="listitem"
    >
      <b>ID: </b>{{ transactionId }}
      <b-icon icon="copy"></b-icon>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { common } from "../../../mixins/common";

export default {
  props: ["invoice", "transactionId"],

  mixins: [common]
};
</script>
